export default {
  SET_USER_DATA: '@MYYOLA/USER/SET_USER_DATA',
  SET_USER_PREFERENCES: '@MYYOLA/USER/SET_USER_PREFERENCES',
  SET_PARTNER_DATA: '@MYYOLA/USER/SET_PARTNER_DATA',
  UPDATE_USER_DATA: '@MYYOLA/USER/UPDATE_USER_DATA',
  UPDATE_USER_PREFERENCES: '@MYYOLA/USER/UPDATE_USER_PREFERENCES',
};
